"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortObjects = void 0;
function sortObjects(objects, key, isAscending) {
    return [
        ...objects.sort((object1, object2) => {
            if (object1[key] < object2[key]) {
                return isAscending ? -1 : 1;
            }
            if (object1[key] > object2[key]) {
                return isAscending ? 1 : -1;
            }
            return 0;
        }),
    ];
}
exports.sortObjects = sortObjects;
//# sourceMappingURL=sortObjects.js.map